import Utility from '@/models/Utility';
import { useCognito, COGNITO_COOKIES_STORAGE, COGNITO_CONFIG } from './useCognito';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

export const useGoogleAuth = () => {
  const userKey = 'kmutt-auth-user';
  const sessionKey = 'kmutt-auth-session';
  const cognito = useCognito();

  const setUser = (user) => {
    // console.log('[useCookieManager.js] setUser:', user);

    localStorage.setItem(userKey, JSON.stringify(user));
    // console.log('[useCookieManager.js] setUser:', localStorage.getItem(userKey));
  };

  const getUser = () => {
    return JSON.parse(localStorage.getItem(userKey));
  };

  const setSession = (session) => {
    localStorage.setItem(sessionKey, JSON.stringify(session));
  };

  const getSession = () => {
    return JSON.parse(localStorage.getItem(sessionKey));
  };

  const initialize = () => {
    const session = getSession();

    const user = getUser();

    if (user && session) {
      user.signOut = () => {
        signOut();
      };

      return { session, user };
    }

    return { session: null, user: null };
  };
  //custom signout function for google use
  const signOut = async () => {
    console.log('[useGoogleAuth.js] Sign out Google user.');
    
    // Clear local storage
    localStorage.removeItem(userKey);
    localStorage.removeItem(sessionKey);

    // Fall back to the catalog's GET /logout, which clears the shared Cognito
    // cookies server-side and ends the (federated) Cognito Hosted UI session.
    const logoutUrl = new URL('/logout', process.env.VUE_APP_CATALOG_APP_URL).toString();

    // Also clear user pool storage using the Cognito SDK
    try {
      const userPool = new CognitoUserPool({ 
        ...COGNITO_CONFIG,
        Storage: COGNITO_COOKIES_STORAGE 
      });
      
      const user = userPool.getCurrentUser();
      if (user) {
        user.signOut();
      }
    } catch (error) {
      console.error("[useGoogleAuth.js] Error clearing Cognito user:", error);
    }

    // Make API call to sign out on the backend
    const response = await Utility.api().signOutGoogle();
    const redirectUrl = response.response.data.URL || logoutUrl;

    // Navigate to the redirect URL which should be the Cognito logout endpoint
    window.location.assign(redirectUrl);
  };

  const refreshSession = async (refreshToken) => {
    try {
      const session = await cognito.refreshGoogleToken(refreshToken);
      let user = getUser();
      if (session && user) {
        user.signOut = () => {
          signOut();
        };
        user.signInUserSession = session;

        setUser(user);
        setSession(session);
        return {
          session: session,
          user: user
        };
      }
      return { session: null, user: null };
    } catch (error) {
      console.log('[useGoogleAuth.js] refreshSession error:', error);
      return Promise.reject({ code: 'NotAuthorizedException' });
    }
  };

  return {
    setUser,
    getUser,
    setSession,
    getSession,
    initialize,
    signOut,
    refreshSession
  };
};
